function Dashboard() {
  return (
    <main>
      <p>Select menu item</p>
    </main>
  )
}

export default Dashboard